const layout = () => import("../../internal/layout.vue");
const revendaFaturamento = () => import("./revendaFaturamento.vue");
const revendaFaturamentoDetalhe = () => import("./revendaFaturamentoDetalhe.vue");

const revendaFaturamentoRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "revendaFaturamento",
      meta: {
        title: "REVENDA FATURAMENTO",
        requiresAuth: true,
      },
      component: revendaFaturamento,
    },
    {
      path: '/revendaFaturamentoDetalhe',
      name: 'revendaFaturamentoDetalhe',
      component: revendaFaturamentoDetalhe,
      meta: {
        title: 'Detalhe Revenda Faturamento',
        requiresAuth: true,
      },
    },
  ],
};

export default revendaFaturamentoRoutes;